module.exports = __webpack_public_path__ + "static/media/login-background.d9258073.jpg";